import * as React from "react";
const SvgFiRrAvocado = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-avocado_svg__a)">
      <path
        fill="#062147"
        d="M12 20c-6.14.017-4.438-10.17 0-10 4.44-.169 6.139 10.018 0 10m0-8c-1.93-.094-3.339 6.106 0 6 3.339.105 1.93-6.093 0-6m0 12c-5.514 0-10-4.119-10-9.182C1.981 2.592 13.721-5.417 17.589 4.355c.905 3.763 4.787 6.352 4.411 10.463C22 19.881 17.514 24 12 24m0-22c-6.37.261-14.267 18.97 0 20 6.356.142 10.443-6.863 6.445-11.68a17 17 0 0 1-2.772-5.39A3.78 3.78 0 0 0 12 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-avocado_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAvocado;
